import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#C9A55C] hover:text-[#C9A55C]/80 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        <h1 className="text-4xl font-serif font-bold text-white mb-8">Mentions Légales</h1>

        <div className="space-y-8 text-white/70">
          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">1. Éditeur du site</h2>
            <p>Le site HELP ADN est édité par :</p>
            <ul className="mt-4 space-y-2">
              <li><strong className="text-white">Nom :</strong> Jennifer Vanderbergue</li>
              <li><strong className="text-white">Statut :</strong> Entrepreneur individuel</li>
              <li><strong className="text-white">SIRET :</strong> 102 160 124 00016</li>
              <li><strong className="text-white">Adresse :</strong> 29 rue Anne Frank, Carvin - Hauts-de-France</li>
              <li><strong className="text-white">Email :</strong> contact@helpadn.fr</li>
              <li><strong className="text-white">Téléphone :</strong> 06 84 63 28 55</li>
              <li><strong className="text-white">TVA :</strong> Non applicable, article 293 B du CGI</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">2. Hébergeur</h2>
            <ul className="space-y-2">
              <li><strong className="text-white">Nom :</strong> Emergent Labs</li>
              <li><strong className="text-white">Site web :</strong> emergent.sh</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">3. Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site (textes, images, logos, graphismes) est la propriété 
              exclusive de HELP ADN, sauf mention contraire. Toute reproduction, distribution, 
              modification ou utilisation de ces contenus sans autorisation préalable est interdite.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">4. Responsabilité</h2>
            <p>
              HELP ADN s'efforce de fournir des informations exactes et à jour. Toutefois, 
              nous ne pouvons garantir l'exactitude, la complétude ou l'actualité des informations 
              diffusées sur ce site. L'utilisation des informations et contenus disponibles sur 
              ce site se fait sous la responsabilité de l'utilisateur.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">5. Liens hypertextes</h2>
            <p>
              Le site peut contenir des liens vers d'autres sites. HELP ADN n'exerce aucun contrôle 
              sur ces sites et décline toute responsabilité quant à leur contenu.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">6. Protection des données personnelles (RGPD)</h2>
            <p className="mb-4">
              <strong className="text-white">Responsable du traitement :</strong> HELP'ADN – Jennifer Vanderbergue.
            </p>
            <p className="mb-4">
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous pouvez exercer 
              vos droits d'accès, de rectification, d'opposition ou de suppression en écrivant à{' '}
              <a href="mailto:contact@helpadn.fr" className="text-[#C9A55C] hover:underline">contact@helpadn.fr</a>.
            </p>
            <p>
              Vous pouvez également introduire une réclamation auprès de la{' '}
              <strong className="text-white">CNIL</strong> (Commission Nationale de l'Informatique et des Libertés) 
              si vous estimez que vos droits ne sont pas respectés.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">7. Intelligence Artificielle - Clause de non-responsabilité</h2>
            <p className="mb-4">
              Les réponses générées par l'agent IA sont produites <strong className="text-white">automatiquement</strong> et 
              peuvent contenir des erreurs. Elles ne constituent pas un avis professionnel et ne remplacent 
              pas l'expertise d'un spécialiste.
            </p>
            <p>
              L'éditeur ne peut être tenu responsable des décisions prises sur la base de ces réponses.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">8. Modération et retrait de contenu</h2>
            <p>
              L'éditeur se réserve le droit de retirer tout contenu généré ou transmis via le service 
              s'il est signalé comme illicite, inapproprié ou contraire aux présentes conditions.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">9. Paiements et conditions de rétractation</h2>
            <p className="mb-4">
              Les paiements peuvent être effectués via <strong className="text-white">PayPal, Stripe, 
              carte bancaire</strong> ou tout autre prestataire sécurisé.
            </p>
            <p className="mb-4">
              Conformément à l'article <strong className="text-white">L221-28 du Code de la consommation</strong>, 
              le droit de rétractation ne s'applique pas aux services numériques fournis immédiatement 
              après paiement, ni aux services personnalisés réalisés à la demande du client.
            </p>
            <p className="p-4 bg-[#C9A55C]/10 border border-[#C9A55C]/30">
              <strong className="text-[#C9A55C]">En procédant au paiement</strong>, quel que soit le moyen utilisé, 
              le client reconnaît demander l'exécution immédiate du service et{' '}
              <strong className="text-white">renonce expressément à son droit de rétractation</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">10. Droit applicable</h2>
            <p>
              Les présentes mentions légales sont régies par le droit français. En cas de litige, 
              les tribunaux français seront seuls compétents.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">11. Médiation</h2>
            <p className="mb-4">
              Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, en cas de litige, 
              l'utilisateur peut recourir gratuitement au médiateur de la consommation : [Nom et coordonnées du médiateur à compléter].
            </p>
            <p>
              Plateforme européenne de règlement des litiges :{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#C9A55C] hover:underline">
                ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">12. Clause de non-concurrence</h2>
            <p className="mb-4">
              L'ensemble des contenus, outils IA, agents, scripts, méthodes, structures, interfaces, 
              produits numériques et services proposés sur ce site sont la propriété exclusive de 
              <strong className="text-white"> HELP'ADN – Jennifer Vanderbergue</strong>.
            </p>
            <p className="mb-4">
              Toute reproduction, imitation, revente, redistribution, création d'un service concurrent 
              ou exploitation commerciale non autorisée est <strong className="text-white">strictement interdite</strong>.
            </p>
            <p>
              Toute tentative de copie ou d'ingénierie inverse des agents IA, modèles, prompts, 
              systèmes ou produits numériques est <strong className="text-white">prohibée</strong>.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">13. Copyright</h2>
            <p className="mb-4">
              Ce site et tous ses contenus (textes, visuels, outils IA, agents, scripts, guides, 
              formations, noms, concepts, structures) sont protégés par le <strong className="text-white">Code de la propriété intellectuelle</strong>.
            </p>
            <p className="mb-4">
              Toute reproduction, modification, diffusion ou exploitation, même partielle, sans 
              autorisation écrite de HELP'ADN, est interdite.
            </p>
            <p className="p-4 bg-[#C9A55C]/10 border border-[#C9A55C]/30 text-center">
              <strong className="text-[#C9A55C]">© HELP'ADN – Jennifer Vanderbergue – Tous droits réservés.</strong>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">14. Création par Intelligence Artificielle</h2>
            <p className="mb-4">
              Ce site web a été conçu et développé avec l'assistance d'outils d'<strong className="text-white">Intelligence Artificielle</strong>.
            </p>
            <p>
              Conformément aux obligations de transparence, nous informons les utilisateurs que des technologies 
              IA ont été utilisées dans la création de ce site et de certains de ses contenus.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-[#C9A55C] mb-4">15. Contact</h2>
            <p className="mb-4">
              Pour toute question concernant ces mentions légales, vous pouvez nous contacter à 
              l'adresse email : <a href="mailto:contact@helpadn.fr" className="text-[#C9A55C] hover:underline">contact@helpadn.fr</a>
            </p>
            <p className="text-[#C9A55C] font-semibold">
              Réponse rapide dans les 2h.
            </p>
          </section>

          <p className="text-sm text-white/40 pt-8 border-t border-[#C9A55C]/20">
            Dernière mise à jour : Juin 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
